import * as React from "react";
import type { SVGProps } from "react";
const SvgBusFront = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#bus-front_svg__a)">
      <path d="M19 20H5c-.55 0-1-.45-1-1V6c0-2.21 1.79-4 4-4h8c2.21 0 4 1.79 4 4v13c0 .55-.45 1-1 1M6 18h12V6c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2z" />
      <path d="M7.49 22H6.5c-.83 0-1.51-.68-1.51-1.51v-1.27c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v1.27c0 .83-.68 1.51-1.51 1.51zM17.49 22h-.99c-.83 0-1.51-.68-1.51-1.51V19c0-.55.45-1 1-1h2c.55 0 1 .45 1 1v1.49c0 .83-.68 1.51-1.51 1.51zM12.1 14H12c-3.47-.01-5.55-.51-7.29-1.04a.997.997 0 0 1-.66-1.25.99.99 0 0 1 1.25-.66c1.59.49 3.5.95 6.71.96 3.29.01 5.12-.47 6.7-.96a.997.997 0 0 1 1.25.66.997.997 0 0 1-.66 1.25c-1.72.53-3.68 1.04-7.19 1.04zM22 12c-.55 0-1-.45-1-1V8c0-.55-.45-1-1-1h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c1.65 0 3 1.35 3 3v3c0 .55-.45 1-1 1M2 12c-.55 0-1-.45-1-1V8c0-1.65 1.35-3 3-3h1c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1 .45-1 1v3c0 .55-.45 1-1 1M9 17H8c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1M16 17h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1" />
      <path d="M20 7H5c-.55 0-1-.45-1-1s.45-1 1-1h15c.55 0 1 .45 1 1s-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="bus-front_svg__a">
        <path fill="#fff" d="M1 2h22v20H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBusFront;
